<nj-sidepanel-layout (sidepanelVisibilityChange)="sidepanelVisibilityChange($event)"
    [style]="'border: var(--nj-semantic-size-border-width) solid var(--nj-semantic-color-border-neutral-minimal);'"
    [isOverContent]="true" #layout>
    <div [style]="'height: 100%; width: 100%; display: grid; place-items: center'">
        <!--        <button nj-button (click)="layout.showPanel()">Open panel</button>
-->
        @if(ShowTradersDashboard) {
        <app-traders-dashboard class="mw80"
            (OnViewInstruction)="ViewTraderInstruction($event)"></app-traders-dashboard>
        }
        @if (ShowRetailDashboard) {
        <app-adhoc-dashboard class="mw80"
            (OnViewInstruction)="ViewInstruction('retail', $event)"></app-adhoc-dashboard>
        }
        @if (ShowFHCDashboard) {
        <app-fhc-dashboard class="mw80"
            (OnViewInstruction)="ViewTraderInstruction($event)"></app-fhc-dashboard>2
        }
        @if (ShowMOWEODashboard) {
        <app-moray-east-dashboard class="mw80"
            (OnViewInstruction)="ViewTraderInstruction($event)"></app-moray-east-dashboard>
        }
        @if (ShowMOWWLDashboard) {
        <app-moray-west-dashboard class="mw80"
            (OnViewInstruction)="ViewTraderInstruction($event)"></app-moray-west-dashboard>
        }@if (ShowResDashboard) {
        <app-res-dashboard class="mw80"
            (OnViewInstruction)="ViewTraderInstruction($event)"></app-res-dashboard>
        }
    </div>
    <nj-sidepanel *njSidepanelLayoutPanel [ngStyle]="{'height': '100vh', 'min-width' : '600px!important'}">
        <nj-sidepanel-header *njSidepanelHeader title="Instruction"
            (closeIconClicked)="layout.hidePanel()"></nj-sidepanel-header>
        <div #contentToPrint>
            <h1>{{Title}}</h1>
            @if (AssetToView == 'AdHoc')
            {
            <app-ad-hoc-viewer [InstructionId]="InstructionIdToView"></app-ad-hoc-viewer>
            }

            @else if (AssetToView == 'retail'){
            <app-ad-hoc-retail-viewer [InstructionId]="InstructionIdToView"></app-ad-hoc-retail-viewer>

            }
            @else if (AssetToView == 'fhc') {
            <app-fhc-viewer [InstructionId]="InstructionIdToView"></app-fhc-viewer>
            }
            @else if (AssetToView == 'moweo') {
            <app-moray-east-viewer [InstructionId]="InstructionIdToView"></app-moray-east-viewer>
            }
            @else if (AssetToView == 'mowwl') {
            <app-moray-west-viewer [InstructionId]="InstructionIdToView"></app-moray-west-viewer>
            }
            @else if (AssetToView == 'res') {
            <app-res-viewer [InstructionId]="InstructionIdToView"></app-res-viewer>
            }
            @else{
            <!--  <app-moray-east-viewer [InstructionId]="InstructionIdToView"></app-moray-east-viewer>
           <app-moray-west-viewer [InstructionId]="InstructionIdToView"></app-moray-west-viewer>
            -->
            }


        </div>
        <div *njSidepanelFooter [style]="'display: flex; align-items: center; justify-content: flex-end;'">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="PrintContent()">
                Print
            </nj-button>

            <!--
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="layout.hidePanel()">
                Close pannel
            </nj-button>
            -->
        </div>
    </nj-sidepanel>
</nj-sidepanel-layout>